import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export const getExpenseTypes = async () => {
  const { data } = await axiosInstance.get("/expenses/types", {
    params: { include_inactive: false },
  });
  return data;
};

export const getExpenses = async (config?: AxiosRequestConfig) => {
  if (config?.params?.sort) {
    config.params.sort = JSON.stringify(config.params.sort);
  }

  if (config?.params?.filters) {
    config.params.filters = JSON.stringify(config.params.filters);
  }

  const { data } = await axiosInstance.get("/expenses", config);
  return data;
};

export const getExpenseDescriptionsSummary = async (
  config?: AxiosRequestConfig
) => {
  if (config?.params?.sort) {
    config.params.sort = JSON.stringify(config.params.sort);
  }

  if (config?.params?.filters) {
    config.params.filters = JSON.stringify(config.params.filters);
  }

  const { data } = await axiosInstance.get(
    "/report/expenses-description-summary",
    config
  );
  return data;
};

export const getReports = async (config?: AxiosRequestConfig) => {
  const { data } = await axiosInstance.get("/report", config);
  return data;
};
